/**
 * 연결 규칙 설정 — 사용자가 규칙마다 고른 1안/2안 (utils/flowRules).
 *
 * 사용자(로그인 ID)별로 이 브라우저에 둔다. 화면 상태(usePersistentState)와 달리 새로고침·재로그인 뒤에도 남아야 하는
 * **개인 설정**이라 브라우저 저장소를 쓴다. 저장소를 못 쓰면(사생활 보호 모드 등) 기본값으로 동작한다.
 */
import { FLOW_RULES, FlowRule, RuleChoice } from './flowRules';

export type RuleChoices = Record<string, RuleChoice>;

const key = (loginId?: string | null) => `openflow:flowRules:${loginId || '-'}`;

export function loadChoices(loginId?: string | null): RuleChoices {
  try {
    const raw = window.localStorage.getItem(key(loginId));
    const v = raw ? JSON.parse(raw) : {};
    return v && typeof v === 'object' ? v : {};
  } catch {
    return {};
  }
}

export function saveChoices(loginId: string | null | undefined, choices: RuleChoices): void {
  try { window.localStorage.setItem(key(loginId), JSON.stringify(choices)); } catch { /* 저장 못 해도 이번 화면에서는 쓴다 */ }
}

/** 이 규칙에 지금 적용할 안 — 고를 수 없는 값이 저장돼 있으면 기본값 */
export function choiceOf(rule: FlowRule, choices: RuleChoices): RuleChoice {
  const c = choices[rule.id];
  return c && rule.options.includes(c) ? c : rule.defaultChoice;
}

export const defaultChoices = (): RuleChoices => Object.fromEntries(FLOW_RULES.map((r) => [r.id, r.defaultChoice]));
